import * as React from "react"
import { useTranslation } from "react-i18next"
import { useLocation } from "react-router-dom"

import { APP_NAME_TITLE } from "@/lib/app-brand"

const BASE = APP_NAME_TITLE

/** Settings URL segment → i18n key for document title (aligned with settings IA). */
const SETTINGS_SECTION_TITLE_KEY: Record<string, string> = {
  general: "settings.page.general.title",
  ai: "settings.page.ai.title",
  notifications: "settings.navNotifications",
  plan: "settings.navPlan",
  account: "settings.navAccount",
}

function titleForPath(pathname: string, t: (key: string) => string): string {
  if (pathname === "/") return `${BASE} — International moves & structured trips`
  if (pathname === "/login") return `${BASE} — Sign in`
  if (pathname === "/sign-up") return `${BASE} — Create account`
  if (pathname === "/reset-password") return `${BASE} — Reset password`
  if (pathname === "/update-password") return `${BASE} — New password`
  if (pathname === "/dashboard") return `${BASE} — Overview`
  if (pathname === "/dashboard/workspaces") return `${BASE} — All trips`
  if (pathname === "/dashboard/workspaces/new") return `${BASE} — New trip`
  if (pathname === "/visa-explorer") return `${BASE} — ${t("visaExplorer.pageTitle")}`
  if (pathname === "/dashboard/visa-explorer") return `${BASE} — ${t("visaExplorer.pageTitle")}`
  if (pathname === "/blog") return `${BASE} — Blog`
  if (pathname.startsWith("/blog/")) return `${BASE} — Blog`
  if (pathname === "/book-demo") return `${BASE} — Book a demo`
  if (pathname === "/contact") return `${BASE} — Contact`
  if (pathname === "/accept-invite") return `${BASE} — Accept invite`
  if (pathname === "/cookies") return `${BASE} — Cookie policy`
  if (pathname === "/terms") return `${BASE} — Terms`
  if (pathname === "/privacy") return `${BASE} — Privacy`
  if (pathname === "/settings") {
    return `${BASE} — ${t("settings.title")}`
  }
  const settingsSection = pathname.match(/^\/settings\/([^/]+)/)
  if (settingsSection) {
    const slug = settingsSection[1]!
    const key = SETTINGS_SECTION_TITLE_KEY[slug]
    if (key) return `${BASE} — ${t(key)}`
    return `${BASE} — ${t("settings.title")}`
  }
  if (pathname === "/admin/settings") return `${BASE} — ${t("admin.settings.nav")}`
  if (pathname === "/admin" || pathname.startsWith("/admin/")) return `${BASE} — Admin`

  if (pathname.match(/^\/workspaces\/[^/]+\/settings\/chatbot/)) {
    return `${BASE} — ${t("workspaceSettings.navChatbot")}`
  }
  const wsMod = pathname.match(
    /^\/workspaces\/[^/]+\/(overview|tasks|documents|resources|finances|settings)/,
  )
  if (wsMod) {
    const mod = wsMod[1]!.replace(/^\w/, (c) => c.toUpperCase())
    return `${BASE} — ${mod}`
  }

  return BASE
}

export function DocumentTitle() {
  const { pathname } = useLocation()
  const { t } = useTranslation()

  React.useEffect(() => {
    document.title = titleForPath(pathname, t)
  }, [pathname, t])

  return null
}
